<div class="snackbar-content">
  <mat-icon class="snackbar-icon">{{ snackBarIcon }}</mat-icon><span class="snackbar-header">{{ snackBarHeader }}</span>
  <div class="snackbar-details">
    {{ snackBarMessage }}
  </div>
</div>